// extracted by mini-css-extract-plugin
module.exports = {"feature_hero":"__feature_hero__VRvWw","feature_content_brief":"__feature_content_brief__D5Og8","features_feature_list_scroll":"__features_feature_list_scroll__2KcLr"};